/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_LiftingInputs */



/**
* | output |
* | --- |
* | "Lifting..." |
*
* @param {Sanction_Mgr_LiftingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_lifting = /** @type {((inputs?: Sanction_Mgr_LiftingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_LiftingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Levée...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Levantando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Removendo...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revoca...")
	return /** @type {LocalizedString} */ ("Lifting...")
});